"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@canonical/react-components");
require("./Footer.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Footer(_ref) {
  let {
    socialLinks,
    additionalLinks,
    optionalLinks,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Strip, {
    type: "light"
  }, children, /*#__PURE__*/_react.default.createElement(_reactComponents.Row, {
    className: "main-footer u-equal-height"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Col, {
    size: 3
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "p-link--soft",
    href: "#main"
  }, "Back to top", /*#__PURE__*/_react.default.createElement("i", {
    className: "p-icon--chevron-up"
  })), /*#__PURE__*/_react.default.createElement("p", null, "\xA9 ", new Date().getFullYear(), " Canonical Ltd."), /*#__PURE__*/_react.default.createElement("ul", {
    className: "p-inline-list"
  }, socialLinks && socialLinks.map(socialLink => /*#__PURE__*/_react.default.createElement("li", {
    className: "p-inline-list__item",
    key: socialLink?.name
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: socialLink?.href
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: socialLink?.iconUrl,
    width: 24,
    height: 24,
    alt: socialLink?.altText
  })))))), /*#__PURE__*/_react.default.createElement(_reactComponents.Col, {
    size: 3
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "p-list u-align-center"
  }, additionalLinks && additionalLinks.map(additionalLink => /*#__PURE__*/_react.default.createElement("li", {
    className: "p-list__item",
    key: additionalLink?.name
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: additionalLink?.href
  }, additionalLink?.name))))), /*#__PURE__*/_react.default.createElement(_reactComponents.Col, {
    size: 6
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "u-align--left"
  }, "Ubuntu and Canonical are registered trademarks of Canonical Ltd."), optionalLinks && optionalLinks.length > 0 && /*#__PURE__*/_react.default.createElement("hr", null), optionalLinks && optionalLinks.map(optionalLink => /*#__PURE__*/_react.default.createElement("li", {
    className: "p-inline-list__item",
    key: optionalLink?.name
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: optionalLink?.href
  }, optionalLink?.name))))));
}
Footer.propTypes = {
  socialLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    iconUrl: _propTypes.default.string.isRequired,
    href: _propTypes.default.string.isRequired,
    altText: _propTypes.default.string.isRequired
  })).isRequired,
  additionalLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    href: _propTypes.default.string.isRequired
  })).isRequired,
  optionalLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    href: _propTypes.default.string.isRequired
  })).isRequired
};
var _default = exports.default = Footer;